import React from 'react'

const ProfileIcon = () => {
  return (
<svg viewBox="0 0 17 17" 
xmlns="http://www.w3.org/2000/svg"
 class="css-1yltdif"
 className='w-5 h-5'><g clip-path="url(#icons__a)">
    <path fill='currentColor' d="M7.494 14.861s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1h-8Zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z">
        </path>
        <path fill='currentColor' fill-rule="evenodd" clip-rule="evenodd" d="M5.71 14.862a2.238 2.238 0 0 1-.216-1c0-1.355.68-2.75 1.936-3.72a6.324 6.324 0 0 0-1.936-.28c-4 0-5 3-5 4s1 1 1 1H5.71Z">
            </path>
            <path fill='currentColor' d="M4.994 8.861a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z">
                </path></g><defs><clipPath id="icons__a">
                    <path fill='currentColor' transform="translate(.494 .861)" d="M0 0h16v16H0z">
                        </path></clipPath></defs>
                        </svg>
  )
}

export default ProfileIcon